module.exports = __webpack_public_path__ + "img/banner3.f17f11f5.jpg";